const GermanySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111480)">
      <path
        d="M1.24365 26.9559C4.06951 34.5718 11.4004 39.9994 19.9997 39.9994C28.599 39.9994 35.9298 34.5718 38.7557 26.9559L19.9997 25.2168L1.24365 26.9559Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435L19.9997 14.7826L38.7557 13.0434C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="black"
      />
      <path
        d="M1.24398 13.043C0.440078 15.2096 0 17.553 0 19.9995C0 22.4459 0.440078 24.7893 1.24398 26.9559H38.7561C39.56 24.7893 40 22.4459 40 19.9995C40 17.553 39.56 15.2096 38.756 13.043H1.24398Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111480">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GermanySvg;
